import React, { Component } from "react";
import { GA_Push } from "../Services/Analytics"

import "./Popup.scss"
//! IF you want to remove the pop up follow these steps
// Hey there future developer [= just follow the instractions and the project will run smothly
// You need to replace the lines of code in the first 2 commits (lines 27 and 29)
// and switch them with the code below them 
// follow the rest of the commits to finish the process 

export default class Popup extends Component {
  constructor() {
    super()
    this.state = {
    }
    this.close = this.close.bind(this);
    this.closeAndChoose = this.closeAndChoose.bind(this);
  }
  close() {
    this.props.triggerPopup();
  }
  closeAndChoose() {
    this.close();
    this.props.chooseMeal(this.props.popupData.data.ID);
  }
  render() {
    return (
      <div>
        {/* <div className={`popupfade${(this.props.isPoping ? " active" : "")}`} onClick={this.close}></div> */}
        <div className={`popupfade active`} ></div>
        {/* <section className={`section section-popup${(this.props.isPoping ? " active" : "")}${(this.props.popupData.isChoosen === true ? "" : (this.props.popupData.isChoosen === false ? "" : " error"))}`}> */}
        <section className={`section section-popup active ${(this.props.popupData.isChoosen === true ? "" : (this.props.popupData.isChoosen === false ? "" : " error"))}`}>
          <div className="padding">
            <div className="container">
              {/* <div className="close" onClick={this.close}></div> */}
              {/* Uncommit this ^ */}
              <div className="headline">
                <div className="left">
                  <div className={`image image-${this.props.popupData.data.Image}`}></div>
                </div>
                <div className="activity-over">הפעילות הסתיימה</div>
                {/* Just commit this one ^ and re */}
                <div className="right">
                  <div className="head">{this.props.popupData.data.Title}</div>
                  <div className="desc">{`${this.props.popupData.data.SubTitle}`}</div>
                  <div className="line"></div>
                  <div className="text"
                    dangerouslySetInnerHTML={{
                      __html: this.props.popupData.data.Describe ?
                        this.props.popupData.data.Describe.replace(/\\n/g, "<br/>") : ""
                    }}></div>
                  <div className={`button${(this.props.popupData.isChoosen === true ? " active" : (this.props.popupData.isChoosen === false ? "" : " hide"))}`} onClick={() => { GA_Push(`Choose_Business - Popup`, "Pic"); this.closeAndChoose() }}>
                    <div className="button-text">
                      {`${(this.props.popupData.isChoosen ? "הסרה" : "בחר/י")}`}
                    </div>
                    <div className="arrow"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div >
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Popup/Popup.jsx